<template>
  <div class="repair-page">
    <div class="repair-card">
      <div class="repair-header">
        <div class="repair-title">工单池</div>
        <div class="repair-divider"></div>
        <div class="repair-toolbar sheet-filter-tabs">
          <div class="repair-actions sheet-tabs">
            <button v-for="item in states" :key="item.statusCd" type="button" :class="['sheet-tab', conditions.state === item.statusCd ? 'is-active' : '']" @click="switchRepairState(item)">{{ item.name }}</button>
            <el-button size="small" class="repair-btn-refresh" title="刷新" @click="fetchData"><i class="el-icon-refresh-right"></i></el-button>
          </div>
        </div>
        <div class="repair-search-sheet">
          <div class="repair-search-group">
            <el-input v-model="conditions.repairId" size="small" clearable placeholder="工单编号" class="repair-search-input small" />
            <el-input v-model="conditions.repairName" size="small" clearable placeholder="报修人" class="repair-search-input small" />
            <el-input v-model="conditions.tel" size="small" clearable placeholder="报修电话" class="repair-search-input small" />
            <el-select v-model="conditions.repairType" size="small" clearable placeholder="请选择报修类型" class="repair-search-select">
              <el-option v-for="item in repairSettings" :key="item.repairType" :label="item.repairTypeName" :value="item.repairType" />
            </el-select>
            <el-input v-model="conditions.repairObjName" size="small" clearable placeholder="报修位置" class="repair-search-input small" />
            <el-select v-model="conditions.maintenanceType" size="small" clearable placeholder="请选择维修类型" class="repair-search-select">
              <el-option v-for="item in maintenanceTypes" :key="item.statusCd" :label="item.name" :value="item.statusCd" />
            </el-select>
            <div class="repair-date-range">
              <el-date-picker v-model="conditions.startTime" size="small" type="date" value-format="yyyy-MM-dd" placeholder="开始时间" class="repair-date" />
              <span class="date-range-separator"></span>
              <el-date-picker v-model="conditions.endTime" size="small" type="date" value-format="yyyy-MM-dd" placeholder="结束时间" class="repair-date" />
            </div>
            <el-button size="small" class="repair-btn-search" @click="queryRepairPool"><i class="el-icon-search"></i>搜索</el-button>
          </div>
        </div>
      </div>

      <div class="repair-table-section">
        <el-table v-loading="loading" :data="repairPools" style="width: 100%" :header-cell-style="headerCellStyle" :cell-style="cellStyle">
          <el-table-column prop="communityName" label="所在小区" min-width="150" show-overflow-tooltip><template slot-scope="scope">{{ scope.row.communityName || '-' }}</template></el-table-column>
          <el-table-column prop="repairId" label="工单编号" min-width="150" show-overflow-tooltip />
          <el-table-column prop="repairObjName" label="位置" min-width="150" show-overflow-tooltip />
          <el-table-column prop="repairTypeName" label="报修类型" min-width="120" show-overflow-tooltip />
          <el-table-column label="维修类型" min-width="120"><template slot-scope="scope">{{ formatMaintenanceType(scope.row.maintenanceType) }}</template></el-table-column>
          <el-table-column prop="repairName" label="报修人" min-width="110" show-overflow-tooltip />
          <el-table-column prop="tel" label="联系方式" min-width="130" show-overflow-tooltip />
          <el-table-column label="预约时间" min-width="190" show-overflow-tooltip><template slot-scope="scope">{{ formatAppointmentRange(scope.row) }}</template></el-table-column>
          <el-table-column prop="createTime" label="预约时间" min-width="170" show-overflow-tooltip />
          <el-table-column label="提单时间" min-width="100"><template slot-scope="scope">{{ scope.row.submitHours || '0' }}</template></el-table-column>
          <el-table-column label="完成时间" min-width="170" show-overflow-tooltip><template slot-scope="scope">{{ scope.row.finishTime || '-' }}</template></el-table-column>
          <el-table-column label="状态" min-width="120"><template slot-scope="scope"><span :class="['status-tag', statusClass(scope.row.state)]">{{ statusText(scope.row) }}</span></template></el-table-column>
          <el-table-column label="操作" min-width="240" fixed="right">
            <template slot-scope="scope">
              <span class="action-links">
                <a class="action-link" @click="openDetail(scope.row)">详情</a>
                <span v-if="scope.row.state === '1000'" class="link-separator"></span>
                <a v-if="scope.row.state === '1000'" class="action-link" @click="openDispatchModal(scope.row)">派单</a>
                <span v-if="canFinishRepair(scope.row)" class="link-separator"></span>
                <a v-if="canFinishRepair(scope.row)" class="action-link" @click="openFinishModal(scope.row)">办理完成</a>
                <span v-if="canEndRepair(scope.row)" class="link-separator"></span>
                <a v-if="canEndRepair(scope.row)" class="action-link danger" @click="openEndModal(scope.row)">结束</a>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="repair-pagination">
        <span class="pagination-total">共{{ page.total }}条</span>
        <el-pagination :current-page="page.current" :page-size="page.size" layout="prev, pager, next, jumper" :total="page.total" @current-change="handleCurrentChange" />
        <el-select v-model="page.size" size="small" class="pagination-size-select" @change="handleSizeChange">
          <el-option label="10条/页" :value="10" />
          <el-option label="20条/页" :value="20" />
          <el-option label="50条/页" :value="50" />
        </el-select>
      </div>
    </div>

    <dispatch-repair ref="dispatchRepair" @success="fetchData" />
    <end-repair ref="endRepair" @success="fetchData" />
    <finish-repair-dialog ref="finishRepairDialog" @success="fetchData" />
    <edit-owner-repair ref="editOwnerRepair" @success="fetchData" />
    <delete-owner-repair ref="deleteOwnerRepair" @success="fetchData" />
  </div>
</template>

<script>
import { listRepairPools } from '@/api/work/repairPoolManageApi'
import { getDict } from '@/api/community/communityApi'
import DispatchRepair from '@/components/work/dispatchRepair'
import EndRepair from '@/components/work/endRepair'
import FinishRepairDialog from '@/components/work/finishRepairDialog'
import EditOwnerRepair from '@/components/work/editOwnerRepair'
import DeleteOwnerRepair from '@/components/work/deleteOwnerRepair'
import { listRepairSettings } from '@/api/work/ownerRepairManageApi'

export default {
  name: 'RepairPoolManage',
  components: { DispatchRepair, EndRepair, FinishRepairDialog, EditOwnerRepair, DeleteOwnerRepair },
  data() {
    return {
      loading: false,
      repairPools: [],
      repairSettings: [],
      states: [],
      maintenanceTypes: [],
      conditions: { repairId: '', repairName: '', tel: '', repairType: '', repairSettingType: '', roomId: '', roomName: '', ownerId: '', state: '', maintenanceType: '', startTime: '', endTime: '', repairObjName: '' },
      page: { current: 1, size: 10, total: 0 }
    }
  },
  created() {
    this.fetchData()
    this.fetchRepairSettings()
    this.loadDictData()
  },
  methods: {
    headerCellStyle() { return { background: '#EBF2FA', color: '#364153', fontWeight: 500, height: '44px', padding: '0', border: 'none' } },
    cellStyle() { return { color: '#1D2129', height: '48px', padding: '0', border: 'none' } },
    async fetchData() {
      this.loading = true
      try {
        const res = await listRepairPools({ ...this.conditions, page: this.page.current, row: this.page.size })
        this.repairPools = res.data || []
        this.page.total = Number(res.total || res.records || 0)
      } finally {
        this.loading = false
      }
    },
    async fetchRepairSettings() {
      const res = await listRepairSettings({ page: 1, row: 100 })
      this.repairSettings = res.data || []
    },
    async loadDictData() {
      this.states = [
        { statusCd: '', name: '全部' },
        { statusCd: 'TIMEOUT', name: '超时工单' },
        { statusCd: '1000', name: '未派单' },
        { statusCd: '1100', name: '接单' },
        { statusCd: '1200', name: '退单' },
        { statusCd: '1900', name: '办理完成' },
        { statusCd: '2000', name: '关闭' }
      ]
      this.maintenanceTypes = await getDict('r_repair_pool', 'maintenance_type')
    },
    formatMaintenanceType(type) { return ((this.maintenanceTypes.find(item => item.statusCd === type) || {}).name) || ({ '1001': '有偿服务', '1002': '无偿服务', '1003': '需要用料', '1004': '无需用料' }[type]) || '-' },
    formatAppointmentRange(row) {
      const start = row.appointmentStartTime || row.appointmentTime || ''
      const end = row.appointmentEndTime || ''
      if (start && end) {
        return `${start} - ${end}`
      }
      return start || '-'
    },
    statusText(row) { return row.state === '1800' && ['001', '002'].includes(row.returnVisitFlag) ? `${row.stateName}(定时任务处理)` : (row.stateName || '-') },
    statusClass(state) { return ['1000', '1200'].includes(state) ? 'status-wait' : (['1800', '1900', '2000'].includes(state) ? 'status-done' : 'status-other') },
    canFinishRepair(row) { return ['1100', '1200', '1300'].includes(row.state) && row.state !== '2001' },
    canEndRepair(row) { return !['1700', '1800', '1900', '2000', '2001'].includes(row.state) },
    switchRepairState(item) { this.conditions.state = item.statusCd; this.page.current = 1; this.fetchData() },
    queryRepairPool() { this.page.current = 1; this.fetchData() },
    openEditModal(repair) { this.$refs.editOwnerRepair.open(repair) },
    openDispatchModal(repair) { this.$refs.dispatchRepair.open(repair) },
    openEndModal(repair) { this.$refs.endRepair.open(repair) },
    openFinishModal(repair) { this.$refs.finishRepairDialog.open(repair) },
    openDetail(repair) { this.$router.push(`/views/work/repairDetail?repairId=${repair.repairId}`) },
    openDeleteModal(repairId) { this.$refs.deleteOwnerRepair.open({ repairId }) },
    handleSizeChange(size) { this.page.size = size; this.page.current = 1; this.fetchData() },
    handleCurrentChange(current) { this.page.current = current; this.fetchData() }
  }
}
</script>

<style scoped>
.repair-page { height: 100%; background: #F5F8FC; }
.repair-card { min-height: 100%; background: #FFFFFF; border-radius: 0 0 12px 12px; display: flex; flex-direction: column; overflow: hidden; }
.repair-header { padding: 20px 24px 12px; flex-shrink: 0; }
.repair-title { font: 600 16px/22px 'PingFang SC', sans-serif; color: #1D2129; }
.repair-divider { height: 1px; background: #DCE6F5; margin: 12px 0; }
.repair-toolbar { display: flex; align-items: center; justify-content: space-between; gap: 16px; }
.repair-actions, .repair-search-group, .action-links, .repair-pagination, .sheet-tabs { display: flex; align-items: center; }
.sheet-filter-tabs { border-bottom: 1px solid #DCE6F5; }
.sheet-tabs { gap: 18px; min-height: 40px; }
.sheet-tab { position: relative; border: none; background: transparent; color: #6A7282; font: 500 14px/20px 'PingFang SC', sans-serif; padding: 0 0 14px; cursor: pointer; }
.sheet-tab.is-active { color: #0E76FF; }
.sheet-tab.is-active::after { content: ''; position: absolute; left: 50%; bottom: -1px; width: 24px; height: 3px; border-radius: 3px; background: #0E76FF; transform: translateX(-50%); }
.repair-search-sheet { margin-top: 16px; }
.repair-search-group { gap: 12px; flex-wrap: wrap; justify-content: flex-start; }
.repair-btn-refresh { width: 38px; height: 38px; padding: 0; border-radius: 10px; border: 1px solid #DCE6F5; color: #364153; background: #fff; }
.repair-btn-search { height: 38px; padding: 0 16px; border-radius: 10px; border: 1px solid #0E76FF; background: #fff; color: #0E76FF; }
.repair-search-input.small, .repair-search-select, .repair-date { width: 150px; }
.repair-search-group >>> .el-input__inner { height: 38px; border-radius: 10px; border-color: #DCE6F5; color: #1D2129; }
.repair-date-range { display: flex; align-items: center; height: 38px; border: 1px solid #DCE6F5; border-radius: 10px; background: #fff; overflow: hidden; }
.repair-date-range .repair-date { width: 140px; }
.repair-date-range >>> .el-input__inner { border: none; border-radius: 0; }
.date-range-separator { width: 1px; height: 18px; background: #DCE6F5; }
.repair-table-section { flex: 1; padding: 12px 24px 0; overflow: auto; }
.repair-table-section >>> .el-table { border-radius: 8px; overflow: hidden; }
.repair-table-section >>> .el-table::before { display: none; }
.repair-table-section >>> .el-table th, .repair-table-section >>> .el-table td { border: none; }
.action-links { gap: 8px; white-space: nowrap; }
.action-link { color: #0E76FF; cursor: pointer; font-size: 14px; }
.action-link.danger { color: #F53F3F; }
.link-separator { width: 1px; height: 12px; background: #DCE6F5; }
.status-tag { display: inline-flex; align-items: center; justify-content: center; min-width: 58px; height: 24px; padding: 0 8px; border-radius: 6px; font-size: 13px; }
.status-wait { background: #FFF7E8; color: #D46B08; }
.status-done { background: #E8F7EF; color: #0E8A45; }
.status-other { background: #E8F3FF; color: #0E76FF; }
.repair-pagination { justify-content: flex-end; gap: 8px; padding: 16px 24px 24px; flex-shrink: 0; }
.pagination-total { color: #6A7282; font-size: 14px; }
.pagination-size-select { width: 96px; }
.pagination-size-select >>> .el-input__inner { height: 32px; border-radius: 8px; }
@media (max-width: 1280px) { .repair-toolbar { align-items: flex-start; flex-direction: column; } }
</style>
